import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { BaseResizableComponent } from '@src/app/modules/base';
import { NavigationItem, NavigationTree, ONLY_LP_SETTINGS_NAVIGATION } from '@src/app/modules/navigation';
import { PreviousRouteService } from '@src/core/services';

@Component({
  selector: 'lp-settings',
  templateUrl: './lp-settings.component.html',
  styleUrls: ['./lp-settings.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LpSettingsComponent extends BaseResizableComponent {
  private readonly previousRouteService = inject(PreviousRouteService);

  selectedItem?: NavigationItem;

  navTree: NavigationTree[] = ONLY_LP_SETTINGS_NAVIGATION;

  get showFullPage(): boolean {
    return !this.selectedItem || this.isLargeScreen;
  }

  onClickReturnButton() {
    this.selectedItem = undefined;
    this.previousRouteService.back('/lp-settings');
  }
}
